module.exports = __webpack_public_path__ + "static/img/aWINDOW.3b34c5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aWINDOW.png
// module id = Wo+s
// module chunks = 1